export default {
  from: 'De',
  perLesson: '/leçon',
}
